import { render } from "./ContentDash.vue?vue&type=template&id=312a2de6"
import script from "./ContentDash.vue?vue&type=script&lang=js"
export * from "./ContentDash.vue?vue&type=script&lang=js"

import "./ContentDash.vue?vue&type=style&index=0&id=312a2de6&scooped=true&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__